export default __webpack_public_path__ + "static/media/PSLogow.27400038.svg";